import { call, put } from 'redux-saga/effects'

import api from 'services/api'

import { Types } from '../ducks/grouping'

export function* fetchGroupingRequest(action) {
  try {
    const { data } = action.payload
    const response = yield call(api.influxdb().getGroupedData, data)

    yield put({
      type: Types.FETCH_SUCCESS,
      payload: {
        data: response.data,
      },
    })
  } catch (err) {
    yield put({
      type: Types.FETCH_FAILURE,
      payload: err.response ? err.response.data.msg : 'UNKNOWN_ERROR',
    })
  }
}
